import api from 'services/api/microfwk';
import { get } from 'lodash';

export const sendForgotPasswordEmail = (params = {}) =>
  api
    .get('/services/user/password_forgot', {
      params,
    })
    .then(({ data }) => {
      const status = get(data, 'status', 0);
      if (parseInt(status, 10) !== 0) return get(data, 'errors', false);
      return data.response;
    })
    .catch(error => {
      const data = get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const sendTemporalCode = (body, params = {}) => {
  const formData = new FormData();
  Object.keys(body).map(key => {
    formData.append(key, body[key]);
    return key;
  });
  return api
    .post('/services/user/sendtemporalcode', formData, {
      params,
    })
    .then(({ data }) => {
      const status = get(data, 'status', 0);
      if (parseInt(status, 10) !== 0) return get(data, 'errors', false);
      return data.response;
    })
    .catch(error => {
      const data = get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
};
